export default __webpack_public_path__ + "static/media/IMG_1988[1].ff2de39b.jpg";